<template>
    <div>
        <div class="container-fluid" style="background-color: white">
            <h2 style="text-align: center">บันทึกค่าใช้จ่ายร้านค้า</h2>
        </div>
        <br>
        <div class="text-center">
            <date-picker
                :lang="lang"
                type="date"
                class="col-10 text-center"
                :format="changeFormat"
                v-model="form.date"
                placeholder="วันที่">
            </date-picker>
        </div>
        <br>
        <div>
            <div class="table">
                <table>
                    <tr>
                        <td>รหัสพนักงาน</td>
                        <td>
                            <input v-model="form.employee.name"
                                   type="text" class="form-control"
                                   disabled/>
                        </td>
                        <td></td>
                        <td>จำนวน</td>
                        <td>
                            <input v-model="form.amount"
                                   type="number" class="form-control"/>
                        </td>
                        <td><label>บาท</label></td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="col text-center">
            <button type="button"
                    @click="submitShopping"
                    class="btn btn-success">
                <icon name="save"></icon>
                บันทึก
            </button>&nbsp;&nbsp;
            <button type="button"
                    @click="cancelShopping"
                    class="btn btn-outline-secondary">
                <icon name="times"></icon>
                ยกเลิก
            </button>
        </div>
        <!--        <pre class="alert-primary">{{form}}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex"
import Multiselect from "vue-multiselect"
import moment from "moment";
import DatePicker from 'vue2-datepicker'

export default {
    name: "shopping-modal",
    components: {
        Multiselect, DatePicker
    },
    created() {
        this.$store.dispatch('ShoppingEmployee/clearFormData')
    },
    data() {
        return {
            currentDate: "",
            isDisabled: true,
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        };
    },
    computed: {
        ...mapState({
            form: state => {
                return state.ShoppingEmployee.form;
            },
            optionEmployee: (state) => {
                return state.Employee.employee_all;
            },
            user: state => {
                return state.Auth.user;
            },
        }),
    },
    methods: {
        addShoppingDetails() {
            this.$store.dispatch("ShoppingEmployee/addShoppingDetails");
        },
        removeShoppingDetails(index) {
            //console.log(index)
            this.$store.dispatch("ShoppingEmployee/removeShoppingDetails", index);
        },
        cancelShopping() {
            this.$emit("submit", 0)
        },
        submitShopping() {
            if (!this.form.employee) {
                alert('กรุณาเลือกพนักงาน')
            } else if (!this.form.amount) {
                alert('กรุณาเใส่จำนวนเงิน')
            } else if (this.form.amount <= 0) {
                alert('กรุณาเใส่จำนวนเงินให้ถูกต้อง')
            } else if (!this.form.date) {
                alert('กรุณาเลือกวันที่')
            } else {
                if (this.form.employee) {
                    this.form.employee_id = this.form.employee.id;
                }

                let data = {
                    id: this.form.id,
                    amount: this.form.amount,
                    employee_id: this.form.employee_id,
                    recorder: this.user.name,
                    date: this.form.date ? moment(this.form.date).format("YYYY-MM-DD") : '',
                }
                this.$emit("submit", data)
            }

        },

    }
}
</script>

<style scoped>

</style>
